<div class="col-md-12">
  <div class="row" style="padding-top: 15px">
    <div class="col-md-12 mt-2 mb-3">
      <h4 class="flex-align-items space-between mb-0">
        <span>{{ 'TlsOptions.label' | translate }} <app-help hrefKey="ExternalHelp.tls" /></span>
        <button type="button" (click)="addTlsOptions()" class="btn btn-sm btn-primary btn-sm">
          <i class="icofont icofont-ui-add"></i>
          <span>{{ 'Ajouter une option' | translate }}</span>
        </button>
      </h4>
    </div>
  </div>
  <div [ngStyle]="{ 'min-height': tlsOptions === null ? '20rem' : null }" class="table-responsive">
    @defer (when tlsOptions !== null) {
      <table class="table table-striped table-condensed" style="border: 1px solid #ccc">
        <thead>
          <tr>
            <th class="name">{{ 'Nom' | translate }}</th>
            <th>{{ 'ClientAuthType.label' | translate }}</th>
            <th>{{ 'mTLS.CaCerts' | translate }}</th>
            <th class="actions">{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @if (tlsOptions.length === 0) {
            <tr>
              <td colspan="4" style="text-align: center">{{ 'NoData' | translate }}</td>
            </tr>
          }
          @for (
            row of tlsOptions
              | paginate
                : {
                    itemsPerPage: size,
                    currentPage: page + 1,
                    totalItems: nbTlsOptions,
                  };
            track row.uid
          ) {
            <tr>
              <td>{{ row.name }}</td>
              <td>{{ 'ClientAuthType.' + row.clientAuthType | translate }}</td>
              <td>
                <ul class="cert-subjects">
                  @for (cert of row.clientAuthCaCerts.map(extractCertInfo); track $index) {
                    <li>{{ cert.subject }} (→ {{ cert.notAfter | dateFormat: 'date' }})</li>
                  }
                </ul>
              </td>
              <td class="actions">
                <a [routerLink]="['tls-options', row.uid]">
                  <i class="icon icon-settings" title="{{ 'Configuration' | translate }}"></i>
                </a>
                <i
                  (click)="deleteTlsOptions(row)"
                  class="icofont icofont-ui-delete"
                  title="{{ 'supprimer' | translate }}"
                ></i>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <div class="flex-align-items pull-right">
        <div class="sites-total mr-3">Total : {{ nbTlsOptions }}</div>
        <pagination-controls
          (pageChange)="changePage($event)"
          nextLabel="{{ 'Next' | translate }}"
          previousLabel="{{ 'Previous' | translate }}"
          style="margin-top: 10px"
        ></pagination-controls>
      </div>
    } @placeholder {
      <div class="loader-track">
        <div class="loader-bar"></div>
      </div>
    }
  </div>
</div>
